import { useRouter } from 'next/router';
import { slackLogger } from '@shared/utils/off-chain/slack-logger';
import { useState } from 'react';
import { createOrUpdateDeepLink } from '@/lib/db/DBDeeplinksHelpers';
import useGetLocation from './useGetLocation';
import useAppDetails from './useAppDetails';
import SlidingModal from '@/components/home/mobile/SlidingModal';
import { Button } from '@/components/ui/button';
import { useTouchHandlerName } from './use-mobile';
export default function useDeepLink() {
  //Notes - the sliding modal was introduced so there was a user interaction before copying - that still didn't work in Safari so going to use IP based linking for deep link mananagement. The modal is still there for future use if we find that IP based tracking doesn't work consistently enought - we can add another step to the modal that specifically copies the deeplink before taking them to the app store. Because we use a webview for our app, the IP should be the same as the device that opens the app.
  const router = useRouter();
  const {
    data: locationData
  } = useGetLocation();
  let fullUrl = router.asPath;
  const {
    referralUrlCode
  } = useAppDetails();
  const touchHandlerName = useTouchHandlerName();
  const [openDeepLinkModal, setOpenDeepLinkModal] = useState(false);
  async function startDeepLinkFlow() {
    let device_data;
    const randomSixChar = Math.random()?.toString(36).substring(2, 8);
    const deviceData = localStorage.getItem('device_data') || null;
    const deeplinkText = `genius-deeplink:${randomSixChar}`;
    const isAppleDevice = APPLE_PATTERNS.some(pattern => pattern.test(navigator.userAgent));
    try {
      try {
        device_data = JSON.parse(deviceData);
      } catch (_) {
        device_data = null;
      }
      if (referralUrlCode && !fullUrl?.includes('code')) {
        fullUrl += fullUrl?.includes('?') ? `&code=${referralUrlCode}` : `?code=${referralUrlCode}`;
      }
      const deepLink = await createOrUpdateDeepLink({
        url: fullUrl,
        identifier: deeplinkText,
        location_data: locationData,
        ip_address: locationData?.ip,
        latitude: locationData?.latitude,
        longitude: locationData?.longitude,
        device_data,
        status: 'pending'
      });
      if (deepLink.error) {
        slackLogger({
          type: 'APPLICATION_ERROR',
          payload: {
            type: 'CREATE_DEEPLINK_ERROR',
            error: deepLink.error,
            pkp: null
          }
        });
      }
    } catch (e) {
      alert(e.message);
      slackLogger({
        type: 'APPLICATION_ERROR',
        payload: {
          type: 'DEEPLINK_OPEN_ERROR',
          error: e.message,
          pkp: null
        }
      });
    } finally {
      if (isAppleDevice) {
        window.location.href = `https://apps.apple.com/us/app/genius-wallet/id6738291878`;
      } else {
        window.location.href = `https://play.google.com/store/apps/details?id=com.tradegenius.xnative`;
      }
    }
  }
  const DeepLinkSlidingModal = () => {
    return <SlidingModal heightFit={true} isOpen={openDeepLinkModal} onClose={() => {
      setOpenDeepLinkModal(!openDeepLinkModal);
    }} data-sentry-element="SlidingModal" data-sentry-component="DeepLinkSlidingModal" data-sentry-source-file="useDeepLink.tsx">
        <div className='px-4 text-sm'>
          We're heading over to the App Store. We'll remember where you left off including if you
          were referred by a friend.
          <Button variant='pink' className='rounded-full w-full py-8 bg-genius-pink mt-4 ' {...{
          [touchHandlerName]: () => {
            startDeepLinkFlow();
          }
        }} data-sentry-element="Button" data-sentry-source-file="useDeepLink.tsx">
            Let's go
          </Button>
        </div>
      </SlidingModal>;
  };
  return {
    DeepLinkSlidingModal,
    openDeepLinkModal,
    setOpenDeepLinkModal,
    startDeepLinkFlow
  };
}
const APPLE_PATTERNS = [/iPhone/i, /iPad/i, /iPod/i, /ios/i, /Apple/i];